import React from 'react';
import './BaseLayout.css';

import { PropaneSharp } from '@mui/icons-material';
import { useState } from 'react';
import Navbar from '../components/navbar/chatnavbar';
import RootView from '../RootView';

const BaseLayout = (props) => {
    const [pageName, setPageName] = useState('');
    const openSection = (pName) => {
        console.log(pName);
        setPageName(pName);
    }
    return (
        <div className="App">
            <div className="rootContainer">
                <div className="nav"></div>
                <div className="aside-2">
                    <Navbar openSection={openSection} />
                </div>
                <div className="wrapper">
                    <div className="header">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div><a href="/login">Login</a>

                        </div>
                    </div>

                    <div className="main">
                        {props.children}
                    </div>
                    <div className="footer">
                        <a href="./privacy.html">Privacy</a><br />
                        <a href="./support.html">Contact us or Support</a><br />
                        <a href="./disclaimer.html">Disclaimer</a><br />
                        &copy; All Rights Reserved
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BaseLayout;

